import { usePlayContext } from "../pages";
import { Sport } from "../redux/slices";
import { MidPoint, PointType } from "../types";
import { calculatePathFromFreeDrawPoints, calculatePathFromFreeDrawPointsHockey } from "../utils";

export interface GetFreeDrawPointsProps {
  tracePoints: MidPoint[];
  shiftHeld: boolean;
}

export const useGetFreeDrawPoints = () => {
  const { playStateApi } = usePlayContext();
  const { sport } = playStateApi.playState;

  const getFreeDrawPoints = ({ tracePoints, shiftHeld }: GetFreeDrawPointsProps): MidPoint[] => {
    // if shift held the line needs to be straight
    if (shiftHeld) {
      const firstPoint = tracePoints[0] || { x: 0, y: 0, pointType: PointType.START };
      const lastPoint = tracePoints[tracePoints.length - 1] || { x: 0, y: 0, pointType: PointType.END };

      return [firstPoint, lastPoint];
    }

    switch (sport) {
      case Sport.BASKETBALL:
      case Sport.SOCCER:
        return calculatePathFromFreeDrawPoints({ tracePathPointsArr: tracePoints });
      case Sport.HOCKEY:
        return calculatePathFromFreeDrawPointsHockey({ tracePathPointsArr: tracePoints, epsilon: 3 });
    }
  };

  return { getFreeDrawPoints };
};
